"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressChangeBanner = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var moment = require("moment");
var commonFunctions_1 = require("../../../commonFunctions");
var AddressChangeBanner = exports.AddressChangeBanner = /** @class */ (function (_super) {
    __extends(AddressChangeBanner, _super);
    function AddressChangeBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            policiesLoaded: false,
            showMissedPaymentBanner: false
        };
        return _this;
    }
    AddressChangeBanner.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies(undefined, services_1.EnumPolicyFilter.NOT_ENDED)
            .subscribe(function (policies) {
            var wolfPolicies = policies.filter(function (policy) { return policy.products.includes(services_1.ProductsEnum.WOLF_MOTOR); }).sort(function (a, b) { return moment(b.endDate).diff(a.endDate); });
            if (wolfPolicies) {
                var agreementVersionIds = wolfPolicies[0].policyHistoryList
                    .filter(function (ph) { return ph.status !== services_1.POLICY_STATUS_MTC; })
                    .map(function (ph) { return ph.id; });
                _this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)
                    .subscribe(function (instalmentsInfo) {
                    _this.setState({ instalmentsInfo: instalmentsInfo });
                });
                wolfPolicies.forEach(function (policy) {
                    _this.customerPortalService.getPolicyPropertiesByPropertyKeys(policy.policyNumber, [services_1.PolicyPropertyEnum.POLICY_DEBT]).subscribe(function (properties) {
                        properties.forEach(function (property) {
                            if (property.key === services_1.PolicyPropertyEnum.POLICY_DEBT) {
                                _this.setState({ showMissedPaymentBanner: _this.state.showMissedPaymentBanner || property.value === "true" });
                            }
                        });
                    });
                });
            }
            _this.setState({
                policies: wolfPolicies,
                policiesLoaded: true
            });
        });
    };
    AddressChangeBanner.prototype.render = function () {
        var wording = "Changes in your address might affect your cover price.";
        if (this.state.showMissedPaymentBanner) {
            if (this.state.instalmentsInfo) {
                var instalmentsInfo = this.state.instalmentsInfo;
                var pendingPaymentInstalments = instalmentsInfo.instalments.filter(function (instalment) { return instalment.status === services_1.INSTALMENT_STATUS_PENDING_PAYMENT; });
                if (pendingPaymentInstalments[0] && pendingPaymentInstalments[0].amount) {
                    wording = wording + " Your change address quote will include your missed payment of " +
                        (0, commonFunctions_1.getAmountToDisplay)(pendingPaymentInstalments[0].amount) + " to bring your account up to date.";
                }
            }
        }
        return (React.createElement("div", { className: "section-panel banner banner-info additional-warning" },
            React.createElement("p", { className: "text-center mb-0 pb-0 font-weight-bold" }, wording)));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AddressChangeBanner.prototype, "customerPortalService", void 0);
    return AddressChangeBanner;
}(React.Component));
//# sourceMappingURL=AddressChangeBanner.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AddressChangeBanner.js
// module id = 3200
// module chunks = 0